export const scoreDetractorsPromoters = {
	3: { bottom: [0, 1], top: [3] },
	4: { bottom: [0, 1], top: [4] },
	5: { bottom: [0, 1, 2], top: [4, 5] },
	6: { bottom: [0, 1, 2], top: [5, 6] },
	7: { bottom: [0, 1, 2], top: [6, 7] },
	8: { bottom: [0, 1, 2], top: [7, 8] },
	9: { bottom: [0, 1, 2], top: [8, 9] },
};
